import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function newPassword (oldPassword, newPassword) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getLogin)
      }, 500)
    })
  } else {
    const req = {
      url: 'api/usuarios/setnewpassword',
      method: 'POST',
      data: {
        OldPassword: oldPassword,
        NewPassword: newPassword
      }
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { newPassword }
